import { usePage } from "@inertiajs/vue3";

export function useHasSubscription(eventType?: { isTeamEventType?: boolean }) {
    const pageProps = usePage();

    //@ts-expect-error
    const subscribedValues = Object.values(pageProps.props.subscribed);

    const hasSubscription =
        subscribedValues.includes(true) || eventType?.isTeamEventType;

    return {
        hasSubscription,
    };
}
